import React, { ReactNode, SVGProps, forwardRef } from 'react'

// Define the IconNode type
export type IconNode = [string, { [key: string]: string | number }][]

// Define props for the Icon component
export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  color?: string
  size?: string | number
  strokeWidth?: string | number
  absoluteStrokeWidth?: boolean
  className?: string
  iconNode: IconNode
  viewBox?: string
  children?: ReactNode
}

// Default SVG attributes
const defaultAttributes: React.SVGProps<SVGSVGElement> = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none'
}

/**
 * Base Icon component for rendering SVG icons
 */
const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ className = '', viewBox, children, iconNode, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        {...defaultAttributes}
        viewBox={viewBox}
        className={`custom-icon shrink-0 ${className}`.trim()}
        {...rest}
      >
        {iconNode.map(([tag, attrs], index) =>
          React.createElement(tag, { ...attrs, key: index })
        )}
        {children}
      </svg>
    )
  }
)

Icon.displayName = 'Icon'

export default Icon
